import { BreakpointObserver } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService, PageService, SettingsService } from '@gallaghercp/core-frontend';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../app.config';
import { ClientService } from '../../services/client.service';

@Component({
    selector: 'core-oops',
    templateUrl: './oops.component.html',
    standalone: false,
})
export class OopsComponent implements OnInit, OnDestroy {
    protected auth = inject(AuthService);
    protected api = inject(HttpClient);
    protected pages = inject(PageService);
    client = inject(ClientService);
    protected settings = inject(SettingsService);
    protected router = inject(Router);
    protected titleService = inject(Title);
    protected breakpoint = inject(BreakpointObserver);

    pageNotFound?: string | undefined;

    copyright: string = APP_CONFIG?.copyright || '';

    loading = false;
    logoUrl!: string;
    subscriptions: Subscription[] = [];
    protected logoInvertedUrl!: string;
    protected logoTransparentUrl!: string;

    ngOnInit() {
        this.titleService.setTitle('Page not found | ' + APP_CONFIG.appName);

        this.subscriptions.push(
            this.settings.getInvertedLogo().subscribe((logoUrl: any) => {
                this.logoInvertedUrl = logoUrl;
                this.updateLogoUrl();
            }),
        );

        this.subscriptions.push(
            this.settings.getTransparentLogo().subscribe((logoUrl: any) => {
                this.logoTransparentUrl = logoUrl;
                this.updateLogoUrl();
            }),
        );
        this.router.navigate(['/']);
    }

    getSiteName() {
        return this.client.getSiteName();
    }

    updateLogoUrl(): void {
        this.logoUrl = this.logoInvertedUrl;
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
}
